import { FC } from 'react'
import { getUserAvatar, sanitizeUrl } from '@/utils'
import { IPublicUser } from '@/types'
import { ProfileCard } from '@components-v2/molecules/ProfileCard'

type Props = {
  user: IPublicUser
}

export const FollowerCard: FC<Props> = ({ user }) => {
  const link = sanitizeUrl(`/users/${user?.username}`)

  return (
    <ProfileCard
      src={getUserAvatar(user)}
      title={user?.name}
      subtitle={user?.profile?.jobTitle}
      size='small'
      href={link}
      withVerifiedTick={user?.profile?.isVerifiedAccount ?? false}
    />
  )
}
